import React from 'react';

const Default = () => {
    return (
        <div>
            Documents List
        </div>
    );
};

export default Default;